// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__ScFNP","form":"LoginForm_form__x4dMq","input":"LoginForm_input__fkwSR","button":"LoginForm_button__rdoIR","error":"LoginForm_error__lRqBF"};